import type { SubscriptionPlanDto } from '@saaga/billingv2-sdk'
import { microsToDollars } from '@saaga/shared/utils/billing.util'

import type { BillingPlan } from '@/components/billing/billing.interface'

export const DEFAULT_PLAN_FEATURES: Record<string, string[]> = {
  free: ['5 chats per month', 'Basic support', 'Community access'],
  starter: [
    '100 chats per month',
    'Email support',
    'API access',
    'Custom agents',
    'Priority queue',
  ],
  pro: [
    'Unlimited chats',
    'Priority support',
    'Advanced API access',
    'Custom agents',
    'Team collaboration',
    'Analytics dashboard',
    'Dedicated account manager',
  ],
}

export const FREE_PLAN: BillingPlan = {
  id: 'plan-free',
  name: 'Free',
  monthlyPrice: 0,
  yearlyPrice: 0,
  featureList: DEFAULT_PLAN_FEATURES.free,
  isPopular: false,
}

export const transformApiPlanToBillingPlan = (plan: SubscriptionPlanDto): BillingPlan => {
  const planNameLower = plan.name.toLowerCase()
  const apiFeatures = plan.features ?? []
  const featureList =
    apiFeatures.length > 0 ? apiFeatures : (DEFAULT_PLAN_FEATURES[planNameLower] ?? [])

  return {
    id: plan.id,
    name: plan.name,
    monthlyPrice: microsToDollars(plan.monthlyPrice),
    yearlyPrice: microsToDollars(plan.yearlyPrice),
    featureList,
    isPopular: planNameLower === 'pro',
  }
}

export const ensureFreePlanInList = (planList: BillingPlan[]): BillingPlan[] => {
  const hasFreePlan = planList.some((plan) => plan.name.toLowerCase() === 'free')
  return hasFreePlan ? planList : [FREE_PLAN, ...planList]
}
